exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-checkbox span {\n  margin-left: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/shared/paiement/create/create.component.scss
// module id = ../../../../../src/app/shared/paiement/create/create.component.scss
// module chunks = main